<template>
  <row-table :columns="columns" :table="table">
    <template slot="row.dose" slot-scope="{ row }">
      <div v-if="row.dose_min">
        <span class="text-gris">Min : </span>
        <span class="whitespace-nowrap">
          {{ row.dose_min }}
          {{ row.dose_unit_min }}
        </span>
      </div>
      <div v-if="row.dose_max">
        <span class="text-gris">Max : </span>
        <span class="whitespace-nowrap">
          {{ row.dose_max }}
          {{ row.dose_unit_max }}
        </span>
      </div>
      <div v-if="row.dose_reco">
        <span class="text-gris">Recommandée : </span>
        <span class="whitespace-nowrap">
          {{ row.dose_reco }}
          {{ row.dose_unit_reco }}
        </span>
      </div>
      <div v-if="row.dose_comment">
        {{ row.dose_comment }}
      </div>
    </template>

    <template slot="row.application" slot-scope="{ row }">
      <div v-if="row.max_nb_application || row.max_nb_application_comment">
        {{ row.max_nb_application }} {{ row.max_nb_application_comment }}
      </div>
      <div>
        {{
          [
            row.intervalle_application
              ? `Intervalle entre 2 applications : ${row.intervalle_application} jour(s)`
              : '',
            row.intervalle_application_comment || ''
          ]
            .filter(Boolean)
            .join(', ')
        }}
      </div>
    </template>

    <template slot="row.fractionnement" slot-scope="{ row }">
      <div v-if="row.fract && row.fract !== 'Non fixé'">
        {{ row.fract }}. {{ row.fract_comment || '' }}
      </div>
      <div v-else>-</div>
      <div v-if="row.fract_dose_max && row.fract_unit_dose_max || row.fract_nb_applications_min || row.fract_nb_applications_max">
        {{
          [
            row.fract_dose_max && row.fract_unit_dose_max
              ? `Dose max par application : ${row.fract_dose_max} ${row.fract_unit_dose_max}`
              : '',
            row.fract_nb_applications_min
              ? `min ${row.fract_nb_applications_min} applications`
              : '',
            row.fract_nb_applications_max
              ? `max ${row.fract_nb_applications_max} applications`
              : ''
          ]
            .filter(Boolean)
            .join(', ')
        }}
      </div>
      <div v-if="row.intervalle_application_fract">
        Intervalle d’application en cas de fractionnement : {{ row.intervalle_application_fract }}
      </div>
    </template>

    <template slot="row.bbch" slot-scope="{ row }">
      <div v-if="row.stade_bbch_start_label ">
        <span class="text-gris">Début : </span>
        {{ row.stade_bbch_start_label }}
      </div>
      <div v-if="row.stade_bbch_end_label">
        <span class="text-gris">Fin : </span>
        {{ row.stade_bbch_end_label }}
      </div>
      <div v-else>-</div>
    </template>

    <template slot="row.abeille" slot-scope="{ row }">
      <div v-if="row.mention_abeille">
        {{ row.mention_abeille }}
      </div>
      <div v-else>-</div>
    </template>

    <template slot="row.dar" slot-scope="{ row }">
      <div v-if="row.info_avant_dar || row.dar || row.info_apres_dar">
        {{
        [
          row.info_avant_dar,
          row.dar ? `${row.dar} jour(s)` : null,
          row.info_apres_dar
        ]
          .filter(Boolean)
          .join(', ')
      }}
      </div>
      <div v-else>
        -
      </div>
      
    </template>

    <template slot="row.dre" slot-scope="{ row }">
      <div v-if="row.dre_local || item.dre_local">
        <span class="text-gris">Locaux : </span>
        <span class="whitespace-nowrap">
          {{ row.dre_local || item.dre_local }} h
        </span>
      </div>
      <div v-if="row.dre_plein_champ || item.dre_plein_champ">
        <span class="text-gris">Plein champ : </span>
        <span class="whitespace-nowrap">
          {{ row.dre_plein_champ || item.dre_plein_champ }} h
        </span>
      </div>
      <div v-if="row.dre_animaux">
        <span class="text-gris">Animaux : </span>
        <span class="whitespace-nowrap"> {{ row.dre_animaux }} jours </span>
        <span>{{ row.dre_animaux_comment }}</span>
      </div>
      <div v-if="!row.dre_local && !item.dre_local && !row.dre_plein_champ && !item.dre_plein_champ && !row.dre_animaux">
        -
      </div>
    </template>
  </row-table>
</template>

<script>
import RowTable from '@/components/RowTable'

export default {
  name: 'TermsRowTable',
  components: { RowTable },
  props: {
    terms: Array,
    item: Object
  },

  data () {
    return {}
  },

  computed: {
    table () {
      return this.terms.map((term) => this.buildRow(term))
    },
    isItemPhyto () {
      return this.item.type === 'Phytopharmaceutique'
    },
    columns () {
      if (!this.isItemPhyto) {
        return [doseColumn]
      }

      return [
        doseColumn,
        applicationColumn,
        fractionnementColumn,
        bbchColumn,
        abeilleColumn,
        darColumn,
        dreColumn
      ]
    }
  },

  methods: {
    buildRow (term) {
      term.dose = term.dose ?? ''
      term.application = term.application ?? ''
      term.fractionnement = term.fractionnement ?? ''
      term.bbch = term.bbch ?? ''
      term.abeille = term.abeille ?? ''
      term.dar = term.dar ?? ''
      term.dre = term.dre ?? ''
      return term
    }
  }
}

const doseColumn = {
  text: 'Dose autorisée',
  value: 'dose'
}

const applicationColumn = {
  text: 'Nombre maximum d’applications',
  value: 'application'
}
const fractionnementColumn = {
  text: 'Fractionnement',
  value: 'fractionnement'
}
const bbchColumn = {
  text: 'Stade d’application (BBCH)',
  value: 'bbch'
}
const abeilleColumn = {
  text: 'Mention abeille',
  value: 'abeille'
}
const darColumn = {
  text: 'DAR (délai avant récolte)',
  value: 'dar'
}
const dreColumn = {
  text: 'DRE (délai de réentrée)',
  value: 'dre'
}
</script>
